import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/blog/blog.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/AppStoreButton/index.tsx");
